import { DropMenuItem } from '@app/components/ui/drop-menu/drop-menu.type';
import useTranslation from '@app/hooks/use-translation';
import { StatisticWidgetsRangeType } from '@app/interfaces/qm-module/qm-statistic/qm-statistic.type';
import { Button, DropMenu } from '@ui';
import React, { FC, useMemo } from 'react';

type RangeBlockPropsType = {
  activeKey: string | undefined;
  onChange(key: string): void;
  keysToHide?: string[];
  rangeFromStor: StatisticWidgetsRangeType | undefined;
};

const RangeBlock: FC<RangeBlockPropsType> = ({
  activeKey,
  onChange,
  rangeFromStor,
  keysToHide,
}) => {
  const { t } = useTranslation('pages.qmManage.statistic');

  const memoDatetimeDropMenuOptions = useMemo<DropMenuItem[]>(() => {
    const defaultMenuOptions = [
      { key: 'cd', title: t('range.cd') },
      { key: 'cw', title: t('range.cw') },
      { key: 'cm', title: t('range.cm') },
      { key: 'pd', title: t('range.pd') },
      { key: 'pw', title: t('range.pw') },
      { key: 'pm', title: t('range.pm') },
      { key: 'r', title: t('range.r') },
      { key: 'n', title: t('range.n'), disable: true },
    ];
    if (!keysToHide?.length) return defaultMenuOptions;
    return defaultMenuOptions.filter(({ key }) => !keysToHide.includes(key));
  }, [t, keysToHide]);
  return (
    <DropMenu activeKey={activeKey} onClick={onChange} menu={memoDatetimeDropMenuOptions}>
      <Button
        label={
          activeKey !== 'r'
            ? memoDatetimeDropMenuOptions.find(({ key }) => key === activeKey)?.title
            : memoDatetimeDropMenuOptions.find(({ key }) => key === activeKey)?.title +
              ': ' +
              rangeFromStor?.parameters?.find((p) => p.condition === '>')?.value?.split(' ')[0] +
              ' - ' +
              rangeFromStor?.parameters?.find((p) => p.condition === '<')?.value?.split(' ')[0]
        }
        iconPosition="right"
        icon="CalendarEmptyIcon"
      />
    </DropMenu>
  );
};

export default RangeBlock;
